import { render, staticRenderFns } from "./News.vue?vue&type=template&id=381befcb&scoped=true&"
import script from "./News.js?vue&type=script&lang=js&"
export * from "./News.js?vue&type=script&lang=js&"
import style0 from "./News.scss?vue&type=style&index=0&id=381befcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381befcb",
  null
  
)

export default component.exports